// extracted by mini-css-extract-plugin
export var container = "_rp-0";
export var table = "_rp-2";
export var tableWrapper = "_rp-1";